import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Package, PackageUpdateTaxRate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePackageTaxRate(): UseMutationResult<
  AxiosResponse<Package>,
  AxiosError<ErrorMessage>,
  PackageUpdateTaxRate
> {
  const queryClient = useQueryClient();

  const updatePackageTaxRate = ({
    packageId,
    taxRate,
  }: PackageUpdateTaxRate): Promise<AxiosResponse<Package>> => {
    return client.put(`packages/${packageId}/update-tax-rate/`, { taxRate });
  };

  return useMutation(updatePackageTaxRate, {
    onSuccess: () => {
      queryClient.invalidateQueries('packages');
    },
  });
}
